import {
  isSchedulePreferenceUserId,
  readSchedulePreferences,
  updateSchedulePreferences,
  type ScheduleColumnWidthView,
} from './schedulePreferencesStorage'

export type { ScheduleColumnWidthView }

export const getScheduleColumnWidthOverrides = (
  userId: number | null | undefined,
  view: ScheduleColumnWidthView,
): Record<string, number> => {
  if (!isSchedulePreferenceUserId(userId)) return {}
  const overrides = readSchedulePreferences()[String(userId)]?.columnWidths?.[view]
  if (!overrides || typeof overrides !== 'object') return {}

  const cleaned: Record<string, number> = {}
  for (const [key, value] of Object.entries(overrides)) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) continue
    if (view === 'week' && /^\d{4}-\d{2}-\d{2}$/.test(key)) continue
    cleaned[key] = value
  }
  return cleaned
}

export const setScheduleColumnWidthOverride = (
  userId: number | null | undefined,
  view: ScheduleColumnWidthView,
  columnKey: string,
  referenceWidthPx: number,
): Record<string, number> => {
  if (!isSchedulePreferenceUserId(userId) || !columnKey) {
    return getScheduleColumnWidthOverrides(userId, view)
  }

  let nextView: Record<string, number> = {}
  updateSchedulePreferences(userId, (current) => {
    const widths = current.columnWidths ?? {}
    nextView = {
      ...(widths[view] ?? {}),
      [columnKey]: referenceWidthPx,
    }
    return {
      ...current,
      columnWidths: {
        ...widths,
        [view]: nextView,
      },
    }
  })
  return nextView
}
